import React, { ReactNode } from 'react';
import { AxiosResponse } from 'axios';
import { StatusMessages } from '../../partials/StatusMessages';
import Btn, { BtnModifier } from '../../../../components/molecules/Btn';

type SubmitButton = {
  buttonLabel: string;
  active?: boolean;
  buttonModifier?: BtnModifier[];
  onClick?: () => void;
  customErrorResponseMapper?: (errorResponse: AxiosResponse<any>) => ReactNode | undefined;
  disabled?: boolean;
} & StatusMessages<any>;

/**
 * Default Submit Button with Status Messages.
 */
export function SubmitButton({
  buttonLabel,
  messageSuccess,
  messageForward,
  messageSending,
  messageFail,
  fetchState,
  active = true,
  customErrorTypeMessages,
  onClick,
  buttonModifier = [],
  customErrorResponseMapper,
  disabled,
  closePreventedMessage,
}: SubmitButton) {
  return (
    <div className="submit-button">
      <div className="submit-button__container">
        <Btn
          ariaDisabled={!active}
          modifier={[BtnModifier.SINGLE_ACTION, BtnModifier.SINGLE_ACTION_YES, ...buttonModifier]}
          text={buttonLabel}
          type="submit"
          onClick={onClick}
          disabled={disabled}
        />
      </div>
      <div className="submit-button__status-message-container">
        <StatusMessages
          messageSuccess={messageSuccess}
          messageForward={messageForward}
          messageSending={messageSending}
          messageFail={messageFail}
          fetchState={fetchState}
          customErrorTypeMessages={customErrorTypeMessages}
          customErrorResponseMapper={customErrorResponseMapper}
          closePreventedMessage={closePreventedMessage}
        />
      </div>
    </div>
  );
}
